import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { RefObject, useEffect, useState } from "react";
import Style from "./mapcomponent.module.scss";

interface PlaceAutocompleteProps {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
  inputRef: RefObject<HTMLInputElement>;
}

const PlaceAutocomplete = ({ onPlaceSelect, inputRef }: PlaceAutocompleteProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const places = useMapsLibrary("places");

  useEffect(() => {
    if (!places || !inputRef.current) return;

    // Das hier geht nicht
    //const autocomplete = new places.Autocomplete(inputRef.current);
    /*autocomplete.setFields([
      "geometry",
      "name",
      "formatted_address",
      "place_id",
      "address_components",
    ]);*/
    //setPlaceAutocomplete(autocomplete);

    // Das hier geht
    const options = {
      fields: ['geometry', 'name', 'formatted_address', 'place_id', 'address_components'],
    };
    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));

  }, [places, inputRef]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    const listener = placeAutocomplete.addListener("place_changed", () => {
      const place = placeAutocomplete.getPlace();

      //Gültigkeit prüfen!
      if (!place || !place.geometry || !place.formatted_address) {
        console.warn("Ungültiger Ort ausgewählt oder kein Ort vorhanden.");
        return;
      }

      onPlaceSelect(place);
    });

    return () => {
      listener.remove(); // 
    };
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <div className={"autocomplete-container " + Style.autocompleteContainer}>
      <input ref={inputRef} onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }} />
    </div>
  );
};

export default PlaceAutocomplete;
